@if (selectedYtjAsiakasData; as ytjAsiakasData) {
  <div style="display: flex; justify-content: space-between; align-items: center" class="otsikko">
    <div class="light-blue-text">YTJ-tiedot</div>
    @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
      <div>
        <app-primary-button (click)="paivitaTiedot($event)" actionId="Päivitä ytj-tiedot manuaalisesti" styles="margin-left: 20px;"> Päivitä tiedot </app-primary-button>
      </div>
    }
    <div style="font-size: 11.2px" class="dark-gray-text">Tiedot tarkistettu viimeksi YTJ:stä {{ ytjAsiakasData.tiedotPaivitetty }}</div>
  </div>
  <div class="info-box">
    <table class="ytj-table">
      <tr>
        <td>
          <table class="ytj-table-1">
            <tr>
              <td>Toiminimi</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['toiminimi']">{{ ytjAsiakasData.toiminimi }}</td>
            </tr>
            <tr>
              <td>Päätoimiala</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['paatoimiala']">{{ ytjAsiakasData.paatoimiala }} ({{ ytjAsiakasData.paatoimialakoodi }})</td>
            </tr>
            <tr>
              <td>Kotipaikka</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['kotipaikka']">{{ ytjAsiakasData.koti }}</td>
            </tr>
            @if (ytjAsiakasData.onkoPostiosoite) {
              <tr>
                <td>Postiosoite</td>
                <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['postiosoite.co'] || !!ytjAsiakasData.versionChangesMap['postiosoite.katu'] || !!ytjAsiakasData.versionChangesMap['postiosoite.nro'] || !!ytjAsiakasData.versionChangesMap['postiosoite.tmp'] || !!ytjAsiakasData.versionChangesMap['postiosoite.maa'] || !!ytjAsiakasData.versionChangesMap['postiosoite.lisatiedot']">
                  @if (ytjAsiakasData.postiosoite.co) {
                    <div>CO {{ ytjAsiakasData.postiosoite.co }}</div>
                  }
                  {{ ytjAsiakasData.postiosoite.katu }} {{ ytjAsiakasData.postiosoite.postinro }} {{ ytjAsiakasData.postiosoite.postitmp }} {{ ytjAsiakasData.postiosoite.maa }}
                  @if (ytjAsiakasData.postiosoite.lisatiedot) {
                    <div>
                      {{ ytjAsiakasData.postiosoite.lisatiedot }}
                    </div>
                  }
                </td>
              </tr>
            }
            @if (ytjAsiakasData.onkoKayntiosoite) {
              <tr>
                <td>Käyntiosoite</td>
                <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['kayntiosoite.co'] || !!ytjAsiakasData.versionChangesMap['kayntiosoite.katu'] || !!ytjAsiakasData.versionChangesMap['kayntiosoite.nro'] || !!ytjAsiakasData.versionChangesMap['kayntiosoite.tmp'] || !!ytjAsiakasData.versionChangesMap['kayntiosoite.maa'] || !!ytjAsiakasData.versionChangesMap['kayntiosoite.lisatiedot']">
                  @if (ytjAsiakasData.kayntiosoite.co) {
                    <div>CO {{ ytjAsiakasData.kayntiosoite.co }}</div>
                  }
                  {{ ytjAsiakasData.kayntiosoite.katu }} {{ ytjAsiakasData.kayntiosoite.postinro }} {{ ytjAsiakasData.kayntiosoite.postitmp }} {{ ytjAsiakasData.kayntiosoite.maa }}
                  @if (ytjAsiakasData.kayntiosoite.lisatiedot) {
                    <div>
                      {{ ytjAsiakasData.kayntiosoite.lisatiedot }}
                    </div>
                  }
                </td>
              </tr>
            }
            <tr>
              <td>&nbsp;</td>
              <td></td>
            </tr>
            <tr>
              <td>Konkurssi</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['konkurssissa']">{{ ytjAsiakasData.konkurssissa ? 'Kyllä' : 'Ei' }}</td>
            </tr>
            <tr>
              <td>Velkajarjestelyssa</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['velkajarjestelyssa']">{{ ytjAsiakasData.velkajarjestelyssa ? 'Kyllä' : 'Ei' }}</td>
            </tr>
            <tr>
              <td>Saneerauksessa</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['saneerauksessa']">{{ ytjAsiakasData.saneerauksessa ? 'Kyllä' : 'Ei' }}</td>
            </tr>
            <tr>
              <td>Selvitystilassa</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['selvitystilassa']">{{ ytjAsiakasData.selvitystilassa ? 'Kyllä' : 'Ei' }}</td>
            </tr>
            <tr>
              <td>Toiminta keskeytetty</td>
              <td [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['toimintakeskeytetty']">{{ ytjAsiakasData.toimintakeskeytetty ? 'Kyllä' : 'Ei' }}</td>
            </tr>
          </table>
        </td>
        <td>
          <table class="rekisteri-table">
            @for (rekisteri of ytjAsiakasData.rekisterit; track rekisteri) {
              <tr [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['rekisteri']">
                <td>{{ rekisteri.nimi }}</td>
                <td>{{ rekisteri.tila }} ({{ rekisteri.p | lokaalipvm | async }})</td>
              </tr>
            }
            @if (ytjAsiakasData.yhteystiedot?.length) {
              <tr>
                <td colspan="2">&nbsp;</td>
              </tr>
              @for (yhteystieto of ytjAsiakasData.yhteystiedot; track yhteystieto; let i = $index) {
                <tr [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['yhteystiedot']">
                  <td>Yhteystieto {{ i + 1 }}</td>
                  <td>{{ yhteystieto.yhteystieto }}</td>
                </tr>
              }
            }
            @if (ytjAsiakasData.henkilo) {
              <tr>
                <td colspan="2">&nbsp;</td>
              </tr>
              <tr [class.ytj-changed]="!!ytjAsiakasData.versionChangesMap['henkilo']">
                <td>Yhteyshenkilö</td>
                <td>{{ ytjAsiakasData.henkilo }}</td>
              </tr>
            }
          </table>
        </td>
      </tr>
    </table>
    <div style="display: flex">
      <div class="blue-text">
        <app-button [disabled]="!ytjPrevActive" (click)="selectDisplayedYtjHistory($event, 'prev', ytjAsiakasData.asiakasAvain)" actionId="YTJ-tiedot: Edellinen versio"> &lt; Edellinen versio </app-button>
        <span style="font-size: 80%; padding: 0 5px" class="dark-gray-text">versio tallennettu {{ ytjAsiakasData.versioLuotu }}</span>
        <app-button [disabled]="!ytjNextActive" (click)="selectDisplayedYtjHistory($event, 'next', ytjAsiakasData.asiakasAvain)" actionId="YTJ-tiedot: Seuraava versio"> Seuraava versio > </app-button>
      </div>
      @if (kuittaaMuutoksetNahdyiksiNakyvissaObservable | async) {
        <app-primary-button (click)="kuittaaMuutoksetNahdyiksi($event)" actionId="Kuittaa YTJ-muutokset nähdyiksi" styles="margin-left: 20px;"> Kuittaa muutokset nähdyiksi </app-primary-button>
      }
    </div>
  </div>
} @else {
  <div style="display: flex; justify-content: space-between; align-items: center" class="otsikko">
    <div class="light-blue-text">YTJ-tiedot</div>
  </div>
}
